import React, {Component} from "react";
import Main from "../../components/smart/Main";
import FocusFour from "../../components/smart/FocusFour";
import MainMessage from "../../components/smart/MainMessage";
import FloatContent from "../../components/smart/FloatContent";
import Logo from './../Logo.png';

class VisionPage extends Component {
    
    render() {
        return (
                <Main Title=" "
                Description=" ">
                    <FocusFour
                   Link1="/Members"
                   Message1="Check the status of a claim or find an explanation of benefits"
                   Link2="/Employers"
                   Message2="Need help with claims resolutions or information on plan designs"
                   Link3="/Providers"
                   Message3="No network, all providers accepted"
                   Link4="/Brokers"
                   Message4="Give your clients the freedom of choosing the provider they love with our reimbursement plan"
                   ></FocusFour>
                    <MainMessage>
                        <div className="Main_Message_Content">
                            <p>
                                Matrix Healthcare offers a premier vision reimbursement plan for employer groups who offer vision benefits to their employees,
                                and our goal is to provide our clients a more personalized experience, along with competitive pricing, excellent coverage, and simplified administration.
                                Our vision plan is focused on maximizing the member experience by demonstrating a zero-disruption plan design.
                                <br></br>Our reimbursement product allows you to go wherever you want!
                                What could be more simple than that?
                            </p>
                        </div>
                        <div className="Main_Message_Logo_Box">
                            <img src={Logo} alt="Logo"></img>
                        </div>  
                    </MainMessage>
                    <FloatContent></FloatContent>
                </Main>         
        )
    }
}

export default VisionPage;
